import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { CustomValidators } from 'ng2-validation';
import {
  AccountsService,
  AuthResponse,
  ResetPasswordParams,
  Unsubscribe,
} from 'src/app/core';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.less'],
})
export class ResetPasswordFormComponent extends Unsubscribe implements OnInit {
  resetForm: FormGroup;
  isSubmitting = false;
  passwordVisible = false;
  confirmPasswordVisible = false;
  password: FormControl;
  confirmPassword: FormControl;
  email: string;
  expiredLinkTimestamp: Date;

  constructor(
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private accountsService: AccountsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();

    this.password = new FormControl('', [
      Validators.maxLength(40),
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(
        '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,40}$'
      ),
    ]);
    this.confirmPassword = new FormControl('', [
      CustomValidators.equalTo(this.password),
    ]);

    this.resetForm = this.fb.group(this.resetFormModel());
    this.email = this.route.snapshot.queryParams['email'];
    this.expiredLinkTimestamp = new Date(
      this.route.snapshot.queryParams['expiration']
    );

    if (this.expiredLinkTimestamp < new Date()) {
      this.router.navigateByUrl('/forgot-password?link-expired=true');
    }
  }

  ngOnInit(): void {}

  resetFormModel(): any {
    return {
      password: this.password,
      confirmPassword: this.confirmPassword,
    };
  }

  submitForm(): void {
    this.isSubmitting = true;

    const resetPasswordParams: ResetPasswordParams = {
      email: this.email,
      newPassword: this.resetForm.get('password').value,
      nonce: this.route.snapshot.queryParams['nonce'],
    };
    this.accountsService
      .resetPassword(resetPasswordParams)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: AuthResponse) => {
          this.isSubmitting = false;
          this.notificationService.success(
            'PAGE.AUTH.RESET_PASSWORD.SUCCESS_TITLE',
            'PAGE.AUTH.RESET_PASSWORD.SUCCESS_MESSAGE',
            '',
            '',
            { nzKey: 'resetPasswordSuccess', nzDuration: 0 }
          );
          setTimeout(() => {
            this.router.navigateByUrl('/login');
          }, 5000);
        },
        (error) => {
          this.notificationService.errorHandler(error);
          this.isSubmitting = false;
        }
      );
  }
}
